import { render, staticRenderFns } from "./reasons-part-replacement.vue?vue&type=template&id=a84c48c6&"
import script from "./reasons-part-replacement.vue?vue&type=script&lang=js&"
export * from "./reasons-part-replacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports